<template>

        <div :class="(enabled?'':'s-d')+' -o-h rlt btn p-n u-8 -r-3 c-20 b-fs '+color+'-b -b b-c'">

          <!-- <transition name="fade"> -->
            <svg v-if="enabled && !result" viewBox="0 0 38 38" :class="'prgc prg-inf abs o-3 u-5 '+color+'-t'">
              <circle cx="50%" cy="50%" r="18" style="stroke-width: 100%;stroke: currentColor;/*! stroke-dashoffset: 100px !important; */"></circle>
            </svg>
          <!-- </transition> -->
          <transition name="fade">
          <div class="u-i b-c">
            <i v-if="!result" :class="color+'-t -i '+(enabled?'pls anm':'')">sports_esports</i>
            <div v-if="enabled && result ===1" class="g b-c">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
            </div>
            <div v-if="enabled && result ===2" class="g b-c">
              <div class="b-c h-4 m-y-1  w-f">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c m-e-a'"></div>
                <div class="u-4"></div>
                <div class="u-4"></div>
              </div>
              <div class="b-c h-4 m-y-1  w-f">
                <div class="u-4"></div>
              </div>
              <div class="b-c h-4 m-y-1  w-f">
                <div class="u-4"></div>
                <div class="u-4"></div>
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c m-s-a'"></div>
              </div>
            </div>
            <div v-if="enabled && result ===3" class="g b-c">
              <div class="b-c h-4 m-y-1  w-f">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c m-e-a'"></div>
              </div>
              <div class="b-c h-4 m-y-1  w-f">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c m-a'"></div>
              </div>
              <div class="b-c h-4 m-y-1  w-f">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c m-s-a'"></div>
              </div>
            </div>
            <div v-if="enabled && result ===4" class="g b-c">
              <div class="b-c h-4 m-y-1  w-f">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
                <div class="u-4"></div>
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
              </div>
              <div class="b-c h-4 m-y-1  w-f">
              </div>
              <div class="b-c h-4 m-y-1  w-f">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
                <div class="u-4"></div>
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
              </div>
            </div>
            <div v-if="enabled && result ===5" class="g b-c">
              <div class="b-c h-4 m-y-1  w-f">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
                <div class="u-4"></div>
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
              </div>
              <div class="b-c h-4 m-y-1  w-f">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
              </div>
              <div class="b-c h-4 m-y-1  w-f">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
                <div class="u-4"></div>
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
              </div>
            </div>
            <div v-if="enabled && result ===6" class="g b-c">
              <div class="b-c h-4 m-y-1">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
                <div class="u-4"></div>
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
              </div>
              <div class="b-c h-4 m-y-1">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
                <div class="u-4"></div>
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
              </div>
              <div class="b-c h-4 m-y-1">
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
                <div class="u-4"></div>
                <div :class="color + ' u-4 m-x-3 m-y-2 b-fs -r-c'"></div>
              </div>
            </div>
            </div>

          </transition>
        </div>
</template>

<script>
export default {
  name: 'DiceWidget',
  props: {
    color: String,
    result: Number,
    enabled: Boolean
  }
}
</script>
